/**
 * Dashboard Context Constants
 * All magic numbers and configuration values for the dashboard context
 */

/**
 * Loading State Timeouts
 * Simulated delays for loading states (in milliseconds)
 */
export const LOADING_TIMEOUTS = {
  /** Default timeout for clearing loading states */
  DEFAULT_LOADING_TIMEOUT: 100,
  /** Timeout for retry operations */
  RETRY_LOADING_TIMEOUT: 100,
} as const;

/**
 * Context Configuration
 * General configuration values for context behavior
 */
export const CONTEXT_CONFIG = {
  /** Whether to auto-calculate statistics on data changes */
  AUTO_CALCULATE_STATISTICS: true,
  /** Whether to clear errors on successful updates */
  CLEAR_ERRORS_ON_UPDATE: true,
} as const;

/**
 * Error Messages
 * Standard error messages for the dashboard context
 */
export const ERROR_MESSAGES = {
  /** Error when context is used outside provider */
  CONTEXT_NOT_FOUND:
    'useDashboard must be used within a DashboardProvider. Wrap your component tree with <DashboardProvider> to access dashboard data.',
} as const;
